import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import SVGConnection from "./SVGConnection.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowEdges',
    props: {
        draggingConnection: null,
        draggingTerminal: null,
        transform: null
    },
    setup(__props) {
        const props = __props;
        const { connectionStore } = useWorkflowStores();
        const { connections } = storeToRefs(connectionStore);
        const draggingConnection = computed(() => {
            if (props.draggingConnection && props.draggingTerminal) {
                const connection = {
                    input: {
                        connectorType: "input",
                        name: "draggingInput",
                        stepId: -1,
                    },
                    output: props.draggingTerminal,
                };
                return [connection, props.draggingConnection];
            }
            else {
                return null;
            }
        });
        function key(connection) {
            return `${connection.input.stepId}-${connection.input.name}-${connection.output.stepId}`;
        }
        function id(connection) {
            return `connection-node-${connection.input.stepId}-input-${connection.input.name}-node-${connection.output.stepId}-output-${connection.output.name}`;
        }
        return { __sfc: true, props, connectionStore, connections, draggingConnection, key, id, SVGConnection };
    }
});
